import React, { useEffect } from "react"
import styled from "styled-components"
import ChannelEpg from "./ChannelEpg"
import "../../other/Transition.css"

const Li = styled.li`
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #829196;
  width: 90% !important;
  left: 5% !important;
  border-bottom: 1px solid #000;
  padding: 0.75rem 0;

  &:focus,
  &:hover {
    outline-width: 0px;
    cursor: pointer;
    border-bottom: 0 solid #000 !important;
  }

  &:hover *,
  &:focus * {
    cursor: pointer;
  }

  & + & {
    margin-top: 0.25rem;
  }
`

const ChannelContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
`

const ChannelMainRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
`

const ChannelNumber = styled.span`
  width: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: 700;
  color: #fff;

  @media (max-width: 900px) {
    font-size: 1.15rem;
  }
`

const Logo = styled.div`
  padding: 0.1rem;
  border-radius: 0.2rem;
  text-align: center;
  width: 3rem;
  height: 3rem;
  font-weight: bold;
  flex-shrink: 0;

  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;

  & > img {
    max-height: 3rem;
    height: auto;
    width: auto;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
`

const Channel = ({
  Name,
  Image,
  Epg,
  Shift,
  Number,
  id,
  selected,
  selectEvent,
  virtualScrollStyle,
}) => {
  useEffect(() => {
    if (selected) {
      setTimeout(() => {
        const selectedElement = document.getElementById("selectedCh")
        if (selectedElement) {
          selectedElement.className += " hvr-shutter-in-horizontal-on"
        }
      }, 100)
    }
  }, [selected])

  return (
    <Li
      tabIndex={-1}
      onClick={!selected ? selectEvent : undefined}
      style={virtualScrollStyle}
      id={selected ? "selectedCh" : ""}
      className={
        selected
          ? "channel hvr-grow-shadow  hvr-shutter-in-horizontal"
          : "channel hvr-reveal hvr-grow-shadow"
      }>
      <ChannelContainer>
        <ChannelMainRow>
          <ChannelNumber>{Number}</ChannelNumber>
          <Logo style={{ backgroundImage: `url(${Image})` }}>
            {
              //<img src={Image} loading={"lazy"} /*onError={()=>{this.onerror=null;this.src='../images/nologo.png?1'}} */ align="middle" alt="" />
            }
          </Logo>
          <ChannelEpg
            Name={Name}
            Epg={Epg}
            Shift={Shift}
            chId={id}
            isPlaying={selected}
          />
        </ChannelMainRow>
      </ChannelContainer>
    </Li>
  )
}

export default Channel
